module.exports = __webpack_public_path__ + "media/icons/match@3x-0d73ce53.png";